module.exports = __webpack_public_path__ + "static/img/sy03.91d39d85.png";